import { render, staticRenderFns } from "./ConsultOnline.vue?vue&type=template&id=2b3b3836&scoped=true&"
import script from "./ConsultOnline.vue?vue&type=script&lang=js&"
export * from "./ConsultOnline.vue?vue&type=script&lang=js&"
import style0 from "./ConsultOnline.vue?vue&type=style&index=0&id=2b3b3836&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b3836",
  null
  
)

export default component.exports